export function bytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v < 10 ? v.toFixed(1) : Math.round(v)} ${units[i]}`;
}

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
export function when(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  const mins = Math.round((d.getTime() - Date.now()) / 60000);
  if (Math.abs(mins) < 60) return mins === 0 ? "just now" : rtf.format(mins, "minute");
  const hours = Math.round(mins / 60);
  if (Math.abs(hours) < 24) return rtf.format(hours, "hour");
  const days = Math.round(hours / 24);
  if (Math.abs(days) < 7) return rtf.format(days, "day");
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}
export const fullDate = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleString() : "");

export function extOf(name: string): string {
  const i = name.lastIndexOf(".");
  return i > 0 ? name.slice(i + 1).toLowerCase() : "";
}

/** "a/b/" -> ["a", "b"] */
export const segments = (path: string) => path.split("/").filter(Boolean);
export const parentOf = (p: string) => {
  const t = p.endsWith("/") ? p.slice(0, -1) : p;
  const i = t.lastIndexOf("/");
  return i < 0 ? "" : t.slice(0, i + 1);
};
export const baseName = (p: string) => {
  const t = p.endsWith("/") ? p.slice(0, -1) : p;
  return t.slice(t.lastIndexOf("/") + 1);
};

/** Client-side mirror of the server's name rules, for instant feedback. The server still decides. */
export function nameProblem(name: string): string | null {
  if (!name.trim()) return "Enter a name";
  if (name !== name.trim()) return "Names can't start or end with a space";
  if (name === "." || name === "..") return "That name isn't allowed";
  if (/[/\\:*?"<>|\u0000-\u001f\u007f]/.test(name)) return 'Names can\'t contain / \\ : * ? " < > |';
  if (name.endsWith(".")) return "Names can't end with a dot";
  if (name.length > 255) return "Name is too long";
  return null;
}
